/* 
 * Export component file to be used on project
*/

import TimerContainer from './TimerContainer.js';
export default TimerContainer;
